import { envConfig } from '../../../../env';
import { Post } from '@/service/request/server';

const baseUrl = envConfig.formalServer + "/cotton/admin/antiAddictionSetting/"

export function insertAntiAddictionSetting(data) {
    return Post(baseUrl + "insertAntiAddictionSetting", data)
}

export function deleteAntiAddictionSetting(data) {
    return Post(baseUrl + "deleteAntiAddictionSetting", data)
}

export function updateAntiAddictionSetting(data) {
    return Post(baseUrl + "updateAntiAddictionSetting", data)
}

export function queryAntiAddictionSetting(data) {
    return Post(baseUrl + "queryAntiAddictionSetting", data)
}

